import { Injectable } from "@angular/core";
import { TypeSafeJson } from "@shared/namespaces/type-safe-json.namespace";
import { TIMER_STORAGE_PREFIX, TimerValues } from "@shared/types/timer/timer";

@Injectable({
  providedIn: "root"
})
export class TimerCleanupService {
  // eslint-disable-next-line @tseslint/class-methods-use-this
  public cleanupExpiredTimers (): void {
    const now: number = Date.now();

    for (let i: number = 0; i < localStorage.length; i++) {
      const key: string | null = localStorage.key(i);

      if (!key?.startsWith(TIMER_STORAGE_PREFIX))
        continue;


      const rawValue: string | null = localStorage.getItem(key);

      if (!rawValue)
        continue;


      try {
        const timerValues: TimerValues = TypeSafeJson.deserialize<TimerValues>(rawValue);

        if (timerValues.startTime + timerValues.duration < now)
          localStorage.removeItem(key);
      } catch {
        localStorage.removeItem(key);
      }
    }
  }
}
